'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootContent = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _navigation = require('program/frontend/actions/navigation');

var _AppBar = require('material-ui/AppBar');

var _AppBar2 = _interopRequireDefault(_AppBar);

var _missMatch = require('program/frontend/components/miss-match');

var _videoViewer = require('../video-viewer');

var _sidebar = require('../sidebar');

var _welcome = require('../welcome');

var _finish = require('../finish');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styles = {

  root: {

    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0

  },

  rootDocked: {

    position: "absolute",
    top: 0,
    left: 256,
    right: 0,
    bottom: 0

  }

};

var RootContent = _react2['default'].createClass({

  displayName: "RootContent",

  componentDidMount: function componentDidMount() {
    var _this = this;

    var dd = null;

    var check = function check() {
      var cur = document.body.offsetWidth > 800;
      if (cur !== dd) {
        dd = cur;
        _this.props.dispatch((0, _navigation.setDockedSidebar)(cur));
      }
    };

    setTimeout(check, 1);
    window.addEventListener("resize", check);
  },
  handleHamburgerClick: function handleHamburgerClick() {

    this.props.dispatch((0, _navigation.setOpenSidebar)(true));
  },
  handleHomeClick: function handleHomeClick() {

    this.props.dispatch((0, _navigation.navigateTo)("/"));
  },
  render: function render() {
    var dockedSidebar = this.props.dockedSidebar;


    return _react2['default'].createElement(
      'div',
      { style: dockedSidebar ? styles.rootDocked : styles.root },
      _react2['default'].createElement(_AppBar2['default'], {
        title: 'SmartFarmer Online-Kurs',
        onLeftIconButtonClick: this.handleHamburgerClick,
        onTitleClick: this.handleHomeClick
      }),
      _react2['default'].createElement(_sidebar.Sidebar, null),
      _react2['default'].createElement(_missMatch.MissMatch, {

        routes: [{
          pattern: "/v/:videoId",
          component: _videoViewer.VideoViewer
        }, {
          pattern: "/finish",
          component: _finish.FinishPage
        }],

        miss: {
          component: _welcome.WelcomePage
        }

      })
    );
  }
});

exports.RootContent = RootContent = (0, _reactRedux.connect)(function (state) {
  return {
    dockedSidebar: state.navigation.dockedSidebar
  };
})(RootContent);

exports.RootContent = RootContent;


//////////////////
// WEBPACK FOOTER
// ./program/frontend/application/content.jsx
// module id = 881
// module chunks = 0